export const FRAME_RATE_LIST = [
  { label: "128", value: "128" },
  { label: "256", value: "256" },
  { label: "512", value: "512" },
  { label: "1024", value: "1024" },
  { label: "2048", value: "2048" },
  { label: "4096", value: "4096" },
  { label: "8192", value: "8192" },
  { label: "16384", value: "16384" },
  { label: "32768", value: "32768" },
  { label: "65536", value: "65536" },
  { label: "131072", value: "131072" },
  { label: "262144", value: "262144" },
];

// ADAPT METHOD OPTIONS
export const ADAPT_METHOD_OPTIONS = [
  {
    label: "Exact",
    value: 0,
    tooltipText:
      "Precision filter for deepest noise suppression in static and slowly changing noise scenes",
  },
  {
    label: "Linear Decay",
    value: 1,
    tooltipText: "Learns initial noise scene quickly and forgets slowly",
  },
  {
    label: "Convex",
    value: 2,
    tooltipText: "Learns changing noise scene quickly and forgets quickly",
  },
  {
    label: "Hybrid",
    value: 3,
    tooltipText:
      "Learns changing noise scene quickly, forgets quickly, suppresses deeply, but may create artificial noise",
  },
  {
    label: "Exponential Decay",
    value: 4,
    tooltipText: "Learns changing noise scene quickly and forgets very quickly",
  },
];

// METHODS
export const PUT = "PUT";
export const POST = "POST";

// FILE TYPES
export const WAV = "WAV";
export const INT16 = "INT16";

// CLIP MERGE/ALIGN RESPONSE MESSAGES
export const RESPONSE_MESSAGE = {
  ALIGNMENT_COMPLETE: "ALIGNMENT COMPLETE",
  ALIGNMENT_FAILED: "ALIGNMENT FAILED",
  CLIP_NOT_FOUND: "CLIP NOT FOUND",
  INSUFFICIENT_CLIPS: "INSUFFICIENT CLIPS",
  CLIP_CASE_MISMATCH: "CLIP CASE MISMATCH",
  CLIP_NOT_READY: "CLIP NOT IN EDITING STATUS",
  SAMPLERATE_MISMATCH: "SAMPLERATE MISMATCH",
  MISSING_ALIGNMENT_DATA: "MISSING ALIGNMENT DATA",
  NO_AUDIO_FILES: "NO AUDIO FILES",
};

// CLIP MERGE/ALIGN RESPONSE STATUSES
export const RESPONSE_STATUS = {
  ALIGNMENT_COMPLETE: "success",
  ALIGNMENT_FAILED: "error",
  FAILURE: "error",
  SUCCESS: "success",
};

export const FILE_TYPES = [
  { label: "INT16", value: "INT16" },
  { label: "AIFF", value: "AIFF" },
  { label: "AU", value: "AU" },
  { label: "FLAC", value: "FLAC" },
  { label: "WAV", value: "WAV" },
];

export const BIN_NUMBER_OF_CHANNELS = [
  { label: "8", value: 8, default: true },
  { label: "16", value: 16, default: false },
];

export const INT16_NUMBER_OF_CHANNELS = [
  { label: "60", value: 60, default: false },
  { label: "70", value: 70, default: false },
  { label: "144", value: 144, default: true },
  { label: "158", value: 158, default: false },
  { label: "196", value: 196, default: false },
  { label: "256", value: 256, default: false },
];

export const WAV_NUMBER_OF_CHANNELS = [
  { label: "2", value: 2, default: true },
  { label: "3", value: 3, default: false },
  { label: "4", value: 4, default: false },
  { label: "5", value: 5, default: false },
  { label: "6", value: 6, default: false },
  { label: "7", value: 7, default: false },
  { label: "8", value: 8, default: false },
  { label: "16", value: 16, default: false },
  { label: "60", value: 60, default: false },
  { label: "70", value: 70, default: false },
  { label: "144", value: 144, default: false },
  { label: "158", value: 158, default: false },
  { label: "256", value: 256, default: false },
];

export const OTHER_NUMBER_OF_CHANNELS = [
  { label: "2", value: 2, default: true },
  { label: "4", value: 4, default: false },
  { label: "6", value: 6, default: false },
  { label: "8", value: 8, default: false },
  { label: "16", value: 16, default: false },
];

export const getNumberOfChannelList = (fileType) => {
  switch (fileType) {
    case "INT16":
      return INT16_NUMBER_OF_CHANNELS;
    case "WAV":
      return WAV_NUMBER_OF_CHANNELS;
    default:
      return OTHER_NUMBER_OF_CHANNELS;
  }
};

export const NOT_TAGGED = "NOT_TAGGED";

// FILTER TYPES
export const ASI = "ASI";
export const NLMS = "NLMS";
export const SNG = "SNG";

export const RECORDING_DEVICE_TYPES = [
  {
    id: 1,
    name: "Other",
    arrayWidth: 0,
    // sync: false,
    allowEdit: true,
    enabled: true,
  },
  {
    id: 4,
    name: "miniDSP UMA-16 Array",
    arrayWidth: 18,
    // sync: true,
    allowEdit: true,
    enabled: true,
  },
  {
    id: 2,
    name: "Smart ePants Garment",
    arrayWidth: 0,
    // sync: false,
    allowEdit: true,
    enabled: true,
  },
  {
    id: 3,
    name: "Squarehead Technologies",
    arrayWidth: 40,
    // sync: true,
    allowEdit: true,
    enabled: true,
  },
  {
    id: 5,
    name: "Dotterel Technologies Konos 2",
    arrayWidth: 0,
    // sync: true,
    allowEdit: true,
    enabled: true,
  },
  {
    id: 6,
    name: "Commesh",
    arrayWidth: 0,
    // sync: true,
    allowEdit: true,
    enabled: true,
  },
  {
    id: 7,
    name: "Embedded Acoustics Pebble",
    arrayWidth: 0,
    // sync: false,
    allowEdit: true,
    enabled: true,
  },
];

export const ASI_FILTER_TAP_NUMBER = [
  { id: 1, label: "512", value: 512 },
  { id: 2, label: "1024", value: 1024 },
  { id: 3, label: "2048", value: 2048 },
  { id: 4, label: "4096", value: 4096 },
  { id: 5, label: "8192", value: 8192 },
  { id: 6, label: "16384", value: 16384 },
  { id: 7, label: "32768", value: 32768 },
  { id: 8, label: "65536", value: 65536 },
  { id: 9, label: "131072", value: 131072 },
  { id: 10, label: "262144", value: 262144 },
];

export const NLMS_ALE_FILTER_TAP_NUMBER = [
  { id: 1, label: "5", value: 5 },
  { id: 2, label: "64", value: 64 },
  { id: 3, label: "128", value: 128 },
  { id: 4, label: "256", value: 256 },
  { id: 5, label: "512", value: 512 },
  { id: 6, label: "1024", value: 1024 },
  { id: 7, label: "2048", value: 2048 },
  { id: 8, label: "4096", value: 4096 },
  { id: 9, label: "8192", value: 8192 },
  { id: 10, label: "16384", value: 16384 },
  { id: 11, label: "32768", value: 32768 },
  { id: 12, label: "65536", value: 65536 },
  { id: 13, label: "131072", value: 131072 },
  { id: 14, label: "262144", value: 262144 },
];

export const NLMS_ANC_FILTER_TAP_NUMBER = [
  { id: 1, label: "256", value: 256 },
  { id: 2, label: "512", value: 512 },
  { id: 3, label: "1024", value: 1024 },
  { id: 4, label: "2048", value: 2048 },
  { id: 5, label: "4096", value: 4096 },
  { id: 6, label: "8192", value: 8192 },
  { id: 7, label: "16384", value: 16384 },
  { id: 8, label: "32768", value: 32768 },
  { id: 9, label: "65536", value: 65536 },
  { id: 10, label: "131072", value: 131072 },
  { id: 11, label: "262144", value: 262144 },
];

export const NLMS_OUTPUT_MODE_TAP_NUMBER = [
  { id: 1, label: "5", value: 5 },
  { id: 2, label: "64", value: 64 },
  { id: 3, label: "128", value: 128 },
  { id: 4, label: "256", value: 256 },
  { id: 5, label: "512", value: 512 },
  { id: 6, label: "1024", value: 1024 },
  { id: 7, label: "2048", value: 2048 },
  { id: 8, label: "4096", value: 4096 },
  { id: 9, label: "8192", value: 8192 },
  { id: 10, label: "16384", value: 16384 },
  { id: 11, label: "32768", value: 32768 },
  { id: 12, label: "65536", value: 65536 },
  { id: 13, label: "131072", value: 131072 },
  { id: 14, label: "262144", value: 262144 },
];

export const SNG_FFT_LENGTH = [
  { id: 1, label: "512", value: 512 },
  { id: 2, label: "1024", value: 1024 },
  { id: 3, label: "2048", value: 2048 },
  { id: 4, label: "4096", value: 4096 },
  { id: 5, label: "8192", value: 8192 },
  { id: 6, label: "16384", value: 16384 },
  { id: 7, label: "32768", value: 32768 },
  { id: 8, label: "65536", value: 65536 },
  { id: 9, label: "131072", value: 131072 },
  { id: 10, label: "262144", value: 262144 },
];

export const WAVE_PROPAGATION_SPEED = [
  { id: 1, label: "Dry Air (34,300)", value: 34300 },
  { id: 2, label: "Fresh Water (148,200)", value: 148200 },
  { id: 3, label: "Seawater (152,000)", value: 152000 },
  { id: 4, label: "Ice (38,000)", value: 38000 },
  { id: 5, label: "Concrete (35,000)", value: 35000 },
  { id: 6, label: "Brick/Masonry (36,000)", value: 36000 },
  { id: 7, label: "Drywall/Gypsum Board (25,000)", value: 25000 },
  { id: 8, label: "Wood - softwood (35,000)", value: 35000 },
  { id: 9, label: "Wood - hardwood (40,000)", value: 40000 },
  { id: 10, label: "Steel (59,000)", value: 59000 },
  { id: 11, label: "Aluminum (63,200)", value: 63200 },
  { id: 12, label: "Soil - dry/loose (30,000)", value: 30000 },
  { id: 13, label: "Soil - compacted (80,000)", value: 80000 },
  { id: 14, label: "Soil - saturated (15,000)", value: 15000 },
  { id: 15, label: "Rock - sedimentary (40,000)", value: 40000 },
  { id: 16, label: "Rock - granite (59,000)", value: 59000 },
];
